import { render } from "./TokenHistory.vue?vue&type=template&id=50d88c31&scoped=true&ts=true"
import script from "./TokenHistory.vue?vue&type=script&lang=ts"
export * from "./TokenHistory.vue?vue&type=script&lang=ts"

import "./TokenHistory.vue?vue&type=style&index=0&id=50d88c31&lang=css"
import "./TokenHistory.vue?vue&type=style&index=1&id=50d88c31&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d88c31"]])

export default __exports__